import { useLocation } from 'react-router-dom';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsContentPageContainerLoadable } from 'modules/cms/pages/Content';
import { MainSearchPageContainerLoadable } from 'modules/main/pages/MainSearch/MainSearchPageContainerLoadable';
import { PostSearchPageContainerLoadable } from 'modules/main/pages/PostSearch/PostSearchPageContainerLoadable';
import { MainStoreContentsState } from 'modules/main/store/ducks/contents';
import { useMainSelector } from 'modules/main/store/hooks/useMainSelector';
import { useAmpContext } from 'utils/AmpContext';
import { hasParam } from 'utils/url';

export function MainCmsPage() {
  const isAmp = useAmpContext();
  const location = useLocation();

  const prefix = isAmp ? /^\/amp\// : /^\//;
  const slug = location.pathname.replace(prefix, '');

  const content = useMainSelector(
    (state) => state?.contents as MainStoreContentsState | undefined,
  )?.byUrl?.[slug] as CmsApiPage | undefined;

  const isLandingPage =
    (content && ['CMS_SEARCH_LANDING_PAGE'].includes(content.type)) || false;

  const { redirectToContent = false }: { redirectToContent?: boolean } =
    location.state || {};

  const isSavedSearchFromEmail = slug.includes('saved-searches');

  if (hasParam(location.search, 'pq')) {
    if (redirectToContent) {
      return <CmsContentPageContainerLoadable slug={slug} amp={isAmp} />;
    }

    return <PostSearchPageContainerLoadable slug={slug} />;
  }

  if (
    hasParam(location.search, 'q') ||
    isSavedSearchFromEmail ||
    isLandingPage
  ) {
    if (redirectToContent) {
      return <CmsContentPageContainerLoadable slug={slug} amp={isAmp} />;
    }

    return <MainSearchPageContainerLoadable slug={slug} />;
  }

  return <CmsContentPageContainerLoadable slug={slug} amp={isAmp} />;
}
